import {sanitizeRelativePath} from "core/transfer/relativePath";
import {declaredContentType} from "core/upload/uploadContract";
import {type FileListFacts, fileListFactsOf} from "./overLimit/fileListRules";

/**
 * The composer's stored-files mode (kitecorp/transferify-ui#3405, owner decision 2026-10-09): the Files tab's
 * "New transfer with these files" opens the composer with files the account already stores, and Send makes a NEW
 * LINK to those same stored files (`POST /account/files/transfers`). Nothing is uploaded and nothing is copied:
 * the composer offers a hosted upload's options, and the api keeps the files' bytes for as long as the longest
 * link to them needs.
 *
 * React-free by mandate (`logic-outside-react`): `CreateFlow` holds the files, the panel lists them.
 */

/** One stored file the composer was handed: what the panel lists, and the id the new link names it by. */
export interface StoredFile {
	id: string;
	name: string;
	size: number;
	contentType: string | null;
	/** The folder path including the name, or null for a file at the root. */
	relativePath: string | null;
}

/** The files as the panel's summary lists picked ones: name, size and the folder path when there is one. */
export function summaryFilesOf(files: readonly StoredFile[]): {name: string; size: number; relativePath?: string}[] {
	return files.map(({name, size, relativePath}) => {
		const path = sanitizeRelativePath(relativePath);
		return path === undefined ? {name, size} : {name, size, relativePath: path};
	});
}

/**
 * The file-list facts the over-limit quote judges (kitecorp/transferify-ui#2930), measured as an upload's
 * declarations are: an absent content type is declared the way the upload declares one.
 */
export function storedFilesListFacts(files: readonly StoredFile[]): FileListFacts {
	return fileListFactsOf(files.map(file => ({name: file.name, contentType: declaredContentType({type: file.contentType ?? ""})})));
}
